import { useHistory, useLocation, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ConfirmModal } from '../../../components/modal/confirm.modal';
import { formatNumber } from '../../../utils/util';
import { reportBelongedDetail, reportRentDetail } from '../../../api/report';

const fakeData = [
  {
    id: '1',
    company: '공주 우진',
    targetDate: '2024-06-22',
    halfTimeCost: '360000',
    fullTimeCost: '720000',
    startTime: '09:00',
    endTime: '16:00',
    workType: '반일',
    squareMeters: '30',
    rpm: '5',
    cost: '360000',
    addWork: '오버타임',
    totalCost: '360000',
    ureaCost: '1300',
    ureaQuantity: '20',
    fuelCost: '1500',
    fuelAmount: '65',
    runDistance: '180',
    AddWorkCost: '240000',
  },
];

interface ReportRentDetailDto {
  ryubeiAmount: number; // 루베 금액
  cycleAmount: number; // 회전 금액
  freshWaterAmount: number; // 청수 금액
  wasteWaterAmount: number; // 폐수 금액
  delayAmount: number; // 지연 금액
  companyId: number; // 회사 아이디
  arrivedAt: string; // 도착시
  goWorkTime: string; // 출근 시간
  leaveWorkTime: string; // 퇴근 시간
  dayType: string; // 작업 형태
  ryubeiVolume: number; // 루베량
  cycleVolume: number; // 회전수
  operationAmount: number; // 운반비
  freshWaterVolume: number; // 청수 횟수
  wasteWaterVolume: number; // 폐수 횟수
  delayVolume: number; // 지연 횟수
  lkmStandard: number; // L/KM 기준값
  lkmAmount: number; // L/KM 기준 금액
  lkmDistance: number; // L/KM 거리
  kmlStandard: number; // KM/L 기준값
  kmlAmount: number; // KM/L 기준 금액
  kmlDistance: number; // KM/L 거리
  ausAmount: number; // 요소수 금액
  ausVolume: number; // 요소수 주유량
  refuelingAmount: number; // 주유 가격
  refuelingVolume: number; // 주유량
  additionAmount: number; // 추가 작업 금액
  additionComment: number; // 추가 작업 내용
  totalAmount: number; // 총 수입 금액
  id: number; // 일보 아이디
  name: string; // 회사 이름
}

interface LocationState {
  selectedType?: string;
  borderLine?: boolean;
}

const UserDairyRentDetail = () => {
  const { id } = useParams<{ id: string }>();
  const data = fakeData.find((item) => item.id === id);

  const [detailData, setDetailData] = useState<ReportRentDetailDto | null>(
    null,
  );

  const history = useHistory();

  const [confirmModal, setConfirmModal] = useState(false);
  const handleConfirmClick = () => {
    setConfirmModal(true);
  };
  const handleConfirmClose = () => {
    setConfirmModal(false);
  };

  const orderRegist = () => {
    history.push({
      pathname: `/userDiary/rent/update/${id}`,
    });
  };

  useEffect(() => {
    const getReportBelongedDetail = async () => {
      try {
        const response = await reportRentDetail(Number(id));
        setDetailData(response);
      } catch (error) {
        console.error(error);
      }
    };

    getReportBelongedDetail();
  }, []);

  return (
    <Container>
      <ul>
        <li>
          <div className="label">회사명</div>
          <div className="value">{detailData?.name}</div>
        </li>
        <li>
          <div className="label">도착 일자</div>
          <div className="value">{detailData?.arrivedAt}</div>
        </li>
        <li>
          <div className="default-cost-box">
            <span className="title">기준금액 설정</span>
            <div className="row-50">
              <div>
                <span className="label">루베</span>
                <span className="value">
                  {detailData?.ryubeiAmount || detailData?.ryubeiAmount === 0
                    ? detailData.ryubeiAmount === 0 ||
                      detailData.ryubeiAmount === null
                      ? '-'
                      : formatNumber(Number(detailData?.ryubeiAmount))
                    : '-'}
                </span>
              </div>
              <div>
                <span className="label">회전</span>
                <span className="value">
                  {detailData?.cycleAmount || detailData?.cycleAmount === 0
                    ? detailData.cycleAmount === 0 ||
                      detailData.cycleAmount === null
                      ? '-'
                      : formatNumber(Number(detailData?.cycleAmount))
                    : '-'}
                </span>
              </div>
            </div>
            <div className="row-50">
              <div>
                <span className="label">청수</span>
                <span className="value">
                  {detailData?.freshWaterAmount ||
                  detailData?.freshWaterAmount === 0
                    ? detailData.freshWaterAmount === 0 ||
                      detailData.freshWaterAmount === null
                      ? '-'
                      : formatNumber(Number(detailData?.freshWaterAmount))
                    : '-'}
                </span>
              </div>
              <div>
                <span className="label">폐수</span>
                <span className="value">
                  {detailData?.wasteWaterAmount ||
                  detailData?.wasteWaterAmount === 0
                    ? detailData.wasteWaterAmount === 0 ||
                      detailData.wasteWaterAmount === null
                      ? '-'
                      : formatNumber(Number(detailData?.wasteWaterAmount))
                    : '-'}
                </span>
              </div>
            </div>
            <div className="row-50 force">
              <div>
                <span className="label">지연</span>
                <span className="value">
                  {detailData?.delayAmount || detailData?.delayAmount === 0
                    ? detailData.delayAmount === 0 ||
                      detailData.delayAmount === null
                      ? '-'
                      : formatNumber(Number(detailData?.delayAmount))
                    : '-'}
                </span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div className="label">출근 시간</div>
          <div className="value">{detailData?.goWorkTime}</div>
        </li>
        <li>
          <div className="label">퇴근 시간</div>
          <div className="value">{detailData?.leaveWorkTime}</div>
        </li>
        <li>
          <div className="label">작업 형태</div>
          <div className="value">
            {detailData?.dayType === 'full' ? '전일' : '반일'}
          </div>
        </li>
        <li>
          <div className="row-50">
            <div>
              <div className="label">루베</div>
              <div className="value">
                {detailData?.ryubeiVolume || detailData?.ryubeiVolume === 0
                  ? detailData.ryubeiVolume === 0 ||
                    detailData.ryubeiVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.ryubeiVolume))
                  : '-'}
              </div>
            </div>
            <div>
              <div className="label">회전수</div>
              <div className="value">
                {detailData?.cycleVolume || detailData?.cycleVolume === 0
                  ? detailData.cycleVolume === 0 ||
                    detailData.cycleVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.cycleVolume))
                  : '-'}
              </div>
            </div>
          </div>
        </li>
        <li className="no-pd">
          <div className="working-cost-box">
            <div className="label">운반비</div>
            <div className="value">
              <span className="won">₩</span>
              {formatNumber(Number(detailData?.operationAmount))}
            </div>
          </div>
        </li>
        <li>
          <div className="row-50">
            <div>
              <span className="label">청수 횟수</span>
              <span className="value">
                {detailData?.freshWaterVolume ||
                detailData?.freshWaterVolume === 0
                  ? detailData.freshWaterVolume === 0 ||
                    detailData.freshWaterVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.freshWaterVolume))
                  : '-'}
              </span>
            </div>
            <div>
              <span className="label">청수 금액</span>
              <span className="value">
                {detailData?.freshWaterVolume ||
                detailData?.freshWaterVolume === 0
                  ? detailData.freshWaterVolume === 0 ||
                    detailData.freshWaterVolume === null
                    ? '-'
                    : formatNumber(
                        Number(detailData?.freshWaterVolume) *
                          Number(detailData.freshWaterAmount),
                      )
                  : '-'}
              </span>
            </div>
          </div>
        </li>
        <li>
          <div className="row-50">
            <div>
              <span className="label">폐수 횟수</span>
              <span className="value">
                {detailData?.wasteWaterVolume ||
                detailData?.wasteWaterVolume === 0
                  ? detailData.wasteWaterVolume === 0 ||
                    detailData.wasteWaterVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.wasteWaterVolume))
                  : '-'}
              </span>
            </div>
            <div>
              <span className="label">폐수 금액</span>
              <span className="value">
                {detailData?.wasteWaterVolume ||
                detailData?.wasteWaterVolume === 0
                  ? detailData.wasteWaterVolume === 0 ||
                    detailData.wasteWaterVolume === null
                    ? '-'
                    : formatNumber(
                        Number(detailData?.wasteWaterVolume) *
                          Number(detailData.wasteWaterAmount),
                      )
                  : '-'}
              </span>
            </div>
          </div>
        </li>
        <li>
          <div className="row-50">
            <div>
              <span className="label">지연 횟수</span>
              <span className="value">
                {detailData?.delayVolume || detailData?.delayVolume === 0
                  ? detailData.delayVolume === 0 ||
                    detailData.delayVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.delayVolume))
                  : '-'}
              </span>
            </div>
            <div>
              <span className="label">지연 금액</span>
              <span className="value">
                {detailData?.delayVolume || detailData?.delayVolume === 0
                  ? detailData.delayVolume === 0 ||
                    detailData.delayVolume === null
                    ? '-'
                    : formatNumber(
                        Number(detailData?.delayVolume) *
                          Number(detailData.delayAmount),
                      )
                  : '-'}
              </span>
            </div>
          </div>
        </li>

        <li className="column">
          <p className="title">L/KM</p>
          <div className="row-50">
            <div>
              <span className="label">기준값</span>
              <span className="value">
                {detailData?.lkmStandard || detailData?.lkmStandard === 0
                  ? detailData.lkmStandard === 0 ||
                    detailData.lkmStandard === null
                    ? '-'
                    : formatNumber(Number(detailData?.lkmStandard))
                  : '-'}
              </span>
            </div>
            <div>
              <span className="label">기준 금액</span>
              <span className="value">
                {detailData?.lkmAmount || detailData?.lkmAmount === 0
                  ? detailData.lkmAmount === 0 || detailData.lkmAmount === null
                    ? '-'
                    : formatNumber(Number(detailData?.lkmAmount))
                  : '-'}
              </span>
            </div>
          </div>
          <div className="row-50">
            <div>
              <span className="label">운행 거리</span>
              <span className="value">
                {detailData?.lkmDistance || detailData?.lkmDistance === 0
                  ? detailData.lkmDistance === 0 ||
                    detailData.lkmDistance === null
                    ? '-'
                    : formatNumber(Number(detailData?.lkmDistance))
                  : '-'}
              </span>
            </div>
            <div>
              <span className="label">받을 금액</span>
              <span className="value">
                {detailData?.lkmStandard === null ||
                detailData?.lkmStandard === 0 ||
                detailData?.lkmAmount === null ||
                detailData?.lkmAmount === 0 ||
                detailData?.lkmDistance === null ||
                detailData?.lkmDistance === 0
                  ? '-' // 하나라도 값이 없으면 '-' 표시
                  : formatNumber(
                      Number(detailData?.lkmStandard) *
                        Number(detailData?.lkmAmount) *
                        Number(detailData?.lkmDistance),
                    )}
              </span>
            </div>
          </div>
        </li>

        <li className="column">
          <p className="title">KM/L</p>
          <div className="row-50">
            <div>
              <span className="label">기준값</span>
              <span className="value">
                {detailData?.kmlStandard || detailData?.kmlStandard === 0
                  ? detailData.kmlStandard === 0 ||
                    detailData.kmlStandard === null
                    ? '-'
                    : formatNumber(Number(detailData?.kmlStandard))
                  : '-'}
              </span>
            </div>
            <div>
              <span className="label">기준 금액</span>
              <span className="value">
                {detailData?.kmlAmount || detailData?.kmlAmount === 0
                  ? detailData.kmlAmount === 0 || detailData.kmlAmount === null
                    ? '-'
                    : formatNumber(Number(detailData?.kmlAmount))
                  : '-'}
              </span>
            </div>
          </div>
          <div className="row-50">
            <div>
              <span className="label">운행 거리</span>
              <span className="value">
                {detailData?.kmlDistance || detailData?.kmlDistance === 0
                  ? detailData.kmlDistance === 0 ||
                    detailData.kmlDistance === null
                    ? '-'
                    : formatNumber(Number(detailData?.kmlDistance))
                  : '-'}
              </span>
            </div>
            <div>
              <span className="label">받을 금액</span>
              <span className="value">
                {detailData?.kmlStandard === null ||
                detailData?.kmlStandard === 0 ||
                detailData?.kmlAmount === null ||
                detailData?.kmlAmount === 0 ||
                detailData?.kmlDistance === null ||
                detailData?.kmlDistance === 0
                  ? '-' // 하나라도 값이 없으면 '-' 표시
                  : formatNumber(
                      Number(detailData?.kmlStandard) *
                        Number(detailData?.kmlAmount) *
                        Number(detailData?.kmlDistance),
                    )}
              </span>
            </div>
          </div>
        </li>

        <li className="gap">
          <div className="row-50">
            <div>
              <div className="label">요소수 금액</div>
              <div className="value">
                {detailData?.ausAmount || detailData?.ausAmount === 0
                  ? detailData.ausAmount === 0 || detailData.ausAmount === null
                    ? '-'
                    : formatNumber(Number(detailData?.ausAmount))
                  : '-'}
              </div>
            </div>
            <div>
              <div className="label">요소수 주유량</div>
              <div className="value">
                {detailData?.ausVolume || detailData?.ausVolume === 0
                  ? detailData.ausVolume === 0 || detailData.ausVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.ausVolume))
                  : '-'}
              </div>
            </div>
          </div>
        </li>
        <li>
          <div className="row-50">
            <div>
              <div className="label">주유 가격/L</div>
              <div className="value">
                {detailData?.refuelingAmount ||
                detailData?.refuelingAmount === 0
                  ? detailData.refuelingAmount === 0 ||
                    detailData.refuelingAmount === null
                    ? '-'
                    : formatNumber(Number(detailData?.refuelingAmount))
                  : '-'}
              </div>
            </div>
            <div>
              <div className="label">주유량(L)</div>
              <div className="value">
                {detailData?.refuelingVolume ||
                detailData?.refuelingVolume === 0
                  ? detailData.refuelingVolume === 0 ||
                    detailData.refuelingVolume === null
                    ? '-'
                    : formatNumber(Number(detailData?.refuelingVolume))
                  : '-'}
              </div>
            </div>
          </div>
        </li>
        <li className="no-pd column">
          <div className="row-30">
            <div>
              <div className="label">추가 작업 금액</div>
              <div className="value">
                {detailData?.additionAmount || detailData?.additionAmount === 0
                  ? detailData.additionAmount === 0 ||
                    detailData.additionAmount === null
                    ? '-'
                    : formatNumber(Number(detailData?.additionAmount))
                  : '-'}
              </div>
            </div>
          </div>
          <div className="row-30">
            <div>
              <div className="label">추가 작업 내용</div>
              <div className="value">
                {detailData?.additionComment === null
                  ? '-'
                  : detailData?.additionComment}
              </div>
            </div>
          </div>
        </li>
        <li>
          <div className="label">총 수입 금액</div>
          <div className="value">
            <span className="won">₩</span>
            {formatNumber(Number(detailData?.totalAmount))}
          </div>
        </li>
      </ul>
      <ConfirmBtn onClick={handleConfirmClick}>수정 하기</ConfirmBtn>
      <AnimatePresence initial={false}>
        {confirmModal ? (
          <ConfirmModal
            handleConfirmClose={handleConfirmClose}
            confirmText="수정 하시겠습니까?"
            onClick={orderRegist}
          />
        ) : null}
      </AnimatePresence>
    </Container>
  );
};

export default UserDairyRentDetail;

// style
const Container = styled.div`
  padding: 0.6rem 1.5rem;
  height: calc(100% - 11rem);
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > ul {
    margin-top: 0rem;
    padding: 2.4rem 1.5rem 7.4rem;
    border-radius: 1.6rem;
    box-shadow: 0 2px 5px 3px rgba(0, 0, 0, 0.05);
    position: relative;
    background-color: ${(props) => props.theme.textWhiteColor};
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    overflow: hidden;
    > li:not(:last-child) {
      display: flex;
      gap: 2.4rem;
      align-items: center;
      padding: 0 0.9rem;
      &.column {
        flex-direction: column;
        gap: 0.6rem;
        p.title {
          font-size: 1.3rem;
          font-weight: 600;
          display: flex;
          justify-content: flex-start;
          width: 100%;
          margin-top: 1rem;
        }
      }
      &.gap {
        margin-top: 1rem;
      }
      &.no-pd {
        padding: 0;
      }
      .label {
        min-width: 5.4rem;
        font-size: 1.2rem;
        font-weight: 600;
        color: ${(props) => props.theme.textAAAColor};
      }
      .value {
        font-size: 1.4rem;
        font-weight: 600;
        &.status {
          min-width: 4.2rem;
          color: ${(props) => props.theme.textWhiteColor};
          background-color: ${(props) => props.theme.btnBlueColor};
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0.4rem;
          font-size: 1.1rem;
          border-radius: 1.1rem;
        }
      }
      .row-50 {
        display: flex;
        align-items: center;
        gap: 2.4rem;
        width: 100%;
        > div {
          flex: 1 1 auto;
          display: flex;
          align-items: center;
          font-size: 1.2rem;
          font-weight: 600;
          gap: 2.4rem;
          color: ${(props) => props.theme.textAAAColor};
          .value {
            color: ${(props) => props.theme.textBlackColor};
            font-size: 1.4rem;
            font-weight: 600;
          }
        }
        &.force {
          width: 50%;
          padding-right: 0.4rem;
        }
      }
      .row-30 {
        display: flex;
        align-items: center;
        gap: 0.8rem;
        width: 100%;
        > div {
          flex: 1 1 30%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 1.6rem 0;
          gap: 0.8rem;
          border-radius: 0.4rem;
          background-color: ${(props) => props.theme.gray10};
          .label {
            min-width: auto;
            color: ${(props) => props.theme.joinLabelColor};
          }
          .value {
            color: ${(props) => props.theme.btnBlueColor};
          }
        }
      }
      .default-cost-box {
        width: 100%;
        margin: 1.2rem 0;
        display: flex;
        flex-direction: column;
        gap: 0.6rem;
        .title {
          margin-bottom: 0.8rem;
          display: flex;
          font-size: 1.4rem;
          font-weight: 600;
        }
        .row-50 {
          gap: 0.8rem;
          > div {
            background-color: ${(props) => props.theme.costBgColor};
            border-radius: 0.4rem;
            color: ${(props) => props.theme.btnBlueColor};
            padding: 1.5rem 1.2rem 1.4rem;
            justify-content: center;
            .label {
              min-width: auto;
              color: ${(props) => props.theme.joinLabelColor};
            }
          }
        }
      }
      .working-cost-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        padding: 1.1rem 1.3rem;
        background-color: ${(props) => props.theme.homeMainBoxBgColor};
        border-radius: 0.8rem;
        color: ${(props) => props.theme.textWhiteColor};
        margin: 0.6rem 0 1.2rem;
        .label {
          color: ${(props) => props.theme.textWhiteColor};
          font-size: 1.3rem;
        }
        .value {
          display: flex;
          gap: 0.4rem;
          align-items: baseline;
          font-size: 1.6rem;
          font-weight: 600;
          .won {
            font-size: 1.2rem;
            color: ${(props) => props.theme.workingTypeColor};
          }
        }
      }
    }
    > li:last-child {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 1.4rem;
      width: 100%;
      background-color: ${(props) => props.theme.btnBlueColor};
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: ${(props) => props.theme.textWhiteColor};
      .label {
        font-size: 1.3rem;
        font-weight: 600;
      }
      .value {
        display: flex;
        gap: 0.4rem;
        align-items: baseline;
        font-size: 1.6rem;
        font-weight: 600;
        .won {
          font-size: 1.2rem;
          color: ${(props) => props.theme.workingTypeColor};
        }
      }
    }
  }
`;

const ConfirmBtn = styled.button`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 9.4rem;
  border: none;
  outline: none;
  padding: 1.7rem;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  background-color: ${(props) => props.theme.btnStrongBlueColor};
  color: ${(props) => props.theme.textWhiteColor};
  font-size: 1.8rem;
  font-weight: 600;
`;
